/**
 * Firms that are no longer current members (DEC-73). Historical rows stay in the database.
 * Live lists, counts, firm pages and the figures ingest writes omit these codes.
 * No departure date is stored: exclusion from current-member figures starts when the code is added.
 * The list is firm codes only.
 */
export const FORMER_FIRM_CODES = ['RSG'];
/** Shown when someone who can open the firm is signed in, and on a direct request for that firm. */
export const FORMER_FIRM_MESSAGE = 'This firm is no longer a current member of the program.';
const CODE = /^[A-Z0-9]{2,8}$/;
const IDENT = /^[A-Za-z_][A-Za-z0-9_]*(\.[A-Za-z_][A-Za-z0-9_]*)?$/;
const FORMER = new Set(FORMER_FIRM_CODES);
export function isFormerFirm(code) {
    return Boolean(code && FORMER.has(code.trim().toUpperCase()));
}
function ident(column) {
    if (!IDENT.test(column))
        throw new Error('former firm column');
    return column;
}
/** SQL predicate. The codes are a fixed list, never request input. */
export function excludeFormerFirms(column) {
    for (const c of FORMER_FIRM_CODES) {
        if (!CODE.test(c))
            throw new Error('former firm code');
    }
    const list = FORMER_FIRM_CODES.map((c) => `N'${c}'`).join(', ');
    return `${ident(column)} NOT IN (${list})`;
}
/** portal_status active, and not a former firm. */
export function whereActiveCurrent(codeColumn = 'firm_code') {
    return `portal_status = N'active' AND ${excludeFormerFirms(codeColumn)}`;
}
/** network_status member, and not a former firm. */
export function whereCurrentMembers(statusColumn = 'network_status', codeColumn = 'firm_code') {
    return `${ident(statusColumn)} = N'member' AND ${excludeFormerFirms(codeColumn)}`;
}
/**
 * Join core.firm for rows that still belong on a live page: portal active, and not a former firm.
 * rowAlias is the firm-scoped table (x, r, s, ...).
 */
export function joinCurrentFirms(rowAlias, firmAlias = 'f') {
    if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(rowAlias) || !/^[A-Za-z_][A-Za-z0-9_]*$/.test(firmAlias))
        throw new Error('former firm alias');
    return `JOIN core.firm ${firmAlias} ON ${firmAlias}.firm_code = ${rowAlias}.firm_code AND ${firmAlias}.portal_status = N'active' AND ${excludeFormerFirms(`${firmAlias}.firm_code`)}`;
}
//# sourceMappingURL=former-firms.js.map